import { useMemo } from 'react';
import { useAuthUser } from '../contexts/useAuthUser';
import { shouldRestrictCatalogToUserAccessWeb } from '../utils/catalogVisibility';
import { useCatalogVitrineSettings } from './useCatalogVitrineSettings';

/** Visibilidade unificada do catálogo na web (vitrine + conteúdo + busca). */
export function useCatalogAccessVisibility() {
  const { data: catalogSettings, refetch } = useCatalogVitrineSettings();
  const { user } = useAuthUser();

  const restrictToUserAccess = useMemo(
    () => shouldRestrictCatalogToUserAccessWeb(catalogSettings, user),
    [catalogSettings, user]
  );

  return {
    catalogSettings,
    restrictToUserAccess,
    refetch,
  };
}
